module.exports = __webpack_public_path__ + "img/twitterLogo.bfef479e.svg";